<template lang="pug">
  .wrap
    //- Jumbo
    .home
      router-link(:to="article.slug" v-for="(article, index) in articles" :key="index" v-if="!article.hidden")
        Hero(:titulo="article.title", :bajada="article.undertitle", :imagen="article.featuredimage", :featuredvideo="article.featuredvideo", :tipo="article.type", :slug="article.slug" :beneathtitle="article.beneathtitle")

</template>

<script>
import { mapState } from 'vuex'
import Jumbo from '@/components/Jumbo'
import Hero from '@/components/Hero'
// import Intro from '@/components/skechers/Intro'

export default {
  name: 'home',
  components: {
    Jumbo,
    Hero
  },
  computed: mapState([
    'articles'
  ]),
  mounted(){
    console.log('mounted!');
  }
}
</script>
<style lang="scss">

</style>
